import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ExitPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      // Trigger when mouse leaves the top of the viewport
      if (e.clientY <= 0 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasShown]);

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            exit={{ opacity: 0 }}
            onClick={() => setIsVisible(false)}
            className="absolute inset-0 bg-black/90 backdrop-blur-sm"
          />
          <motion.div 
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="bg-brand-black border border-brand-yellow/30 rounded-2xl p-6 md:p-8 max-w-xl w-full relative z-10 shadow-[0_0_50px_rgba(255,214,49,0.15)] overflow-hidden"
          >
            <button 
              onClick={() => setIsVisible(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors z-20"
            >
              <SafeIcon icon={FiX} size={24} />
            </button>
            
            <div className="text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                Wait! Don't leave empty handed.
              </h3>
              <p className="text-gray-400 mb-6 text-sm md:text-base">
                Get 10 free translations from the book sent to your inbox.
              </p>
              
              {/* NordicCRM Form Embed - Fixed Whitespace */}
              <div className="relative w-full overflow-hidden rounded-lg">
                <iframe
                  src="https://link.nordiccrm.ca/widget/form/rnnUT7HPMPvpW0sj43iY"
                  style={{ 
                    width: '100%', 
                    height: '435px', // Adjusted height to fit form content tighter
                    border: 'none', 
                    borderRadius: '8px',
                    display: 'block'
                  }}
                  id="inline-rnnUT7HPMPvpW0sj43iY"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivated"
                  data-deactivation-value=""
                  data-form-name="Exit Intent Form"
                  data-scrollbar="no" // Disabled scrollbar within iframe if possible
                  data-auto-height="false"
                  title="Exit Intent Form"
                ></iframe>
              </div>

              <button 
                onClick={() => setIsVisible(false)}
                className="mt-6 text-sm text-gray-500 hover:text-brand-yellow transition-colors underline underline-offset-4"
              >
                No thanks, I'll keep guessing
              </button>
            </div>

            {/* Subtle glow effect */}
            <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-brand-yellow/10 blur-[80px] rounded-full -z-10"></div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ExitPopup;